// Прелоадер главной (разметка и стили — в public/index.html).
// Ждёт шрифты и картинки, которые браузер уже начал грузить для первого экрана,
// показывает прогресс и плавно растворяется. Дольше MAX_WAIT_MS не держит:
// медленный интернет не должен запирать сайт.

const MAX_WAIT_MS = 8000;
const FADE_MS = 800;

let started = false;
let finished = false;
// Загрузки, без которых главная собирается не до конца (новости, FAQ,
// настройки сайта): иначе экраны и точки справа появлялись бы уже после
// прелоадера
const pending: Promise<unknown>[] = [];

/** Учесть загрузку данных главной в прелоадере. */
export function trackPreload<T>(p: Promise<T>): Promise<T> {
  if (!finished) pending.push(p.catch(() => undefined));
  return p;
}

/** Ждём все учтённые загрузки, включая начатые по ходу ожидания. */
async function settlePending(): Promise<void> {
  let seen = -1;
  while (seen !== pending.length) {
    seen = pending.length;
    await Promise.all(pending.slice());
    // даём React отрисовать пришедшие данные и начать следующие загрузки
    await new Promise((r) => window.setTimeout(r, 50));
  }
}

/** Убрать прелоадер сразу, без ожидания (не главная страница). */
export function removePreloader(): void {
  finished = true;
  document.getElementById('site-preloader')?.remove();
}

/** Дождаться загрузки главной и плавно убрать прелоадер. */
export function runMainPreloader(): void {
  const el = document.getElementById('site-preloader');
  if (!el || started) return;
  started = true;

  const bar = el.querySelector<HTMLElement>('.pl-bar i');
  const cap = el.querySelector<HTMLElement>('.pl-cap b');
  let shown = 0;
  const setProgress = (value: number) => {
    const v = Math.max(shown, Math.min(100, Math.round(value)));
    shown = v;
    if (bar) bar.style.width = `${Math.max(4, v)}%`;
    if (cap) cap.textContent = `${v}%`;
  };

  // Картинки, уже вставленные React (ленивые не ждём — они ниже первого экрана)
  const images = Array.from(document.images).filter((img) => img.loading !== 'lazy');
  const tasks: Promise<unknown>[] = images.map((img) =>
    img.complete ? Promise.resolve() : new Promise((resolve) => {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    }),
  );
  tasks.push(document.fonts ? document.fonts.ready : Promise.resolve());
  tasks.push(settlePending());
  tasks.push(document.readyState === 'complete'
    ? Promise.resolve()
    : new Promise((resolve) => window.addEventListener('load', resolve, { once: true })));

  let done = 0;
  tasks.forEach((t) => t.then(() => { done += 1; setProgress((done / tasks.length) * 100); }));

  const finish = () => {
    finished = true;
    setProgress(100);
    window.setTimeout(() => {
      el.classList.add('pl-done');
      window.setTimeout(() => el.remove(), FADE_MS);
    }, 250);
  };
  Promise.race([
    Promise.all(tasks),
    new Promise((resolve) => window.setTimeout(resolve, MAX_WAIT_MS)),
  ]).then(finish);
}
